/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnInit, Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { type HttpResponse, I18nService } from '@dm/core';
import { SIMPLE_MODE_PATH } from 'app/common/constants/simple-mode.const';
import { ToolService } from 'app/common/services';
import { SimpleModeService } from 'app/common/services/simple-mode.service';
import { SWITCH } from 'app/config';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
    selector: 'app-simple-mode-switch',
    templateUrl: './simple-mode-switch.component.html',
    styleUrls: ['./simple-mode-switch.component.scss'],
})
export class SimpleModeSwitchComponent implements OnInit {
    /**
     * 是否有LUN的license
     */
    @Input() hasLunLicense: boolean;

    i18nStr = {
        advanceModeTip: this.i18n.get('home.switchToStandardMode_tip'),
        simpleModeTip: this.i18n.get('home.switchToSimplifiedMode_tip'),
    };

    get isSimpleMode(): boolean {
        return SWITCH.IS_SIMPLE_MODE;
    }
    supportSmartThin = this.toolService.supportSmartThinLicense();

    constructor(
        private i18n: I18nService,
        private router: Router,
        private simpleModeService: SimpleModeService,
        private toolService: ToolService,
    ) { }

    ngOnInit(): void {

    }

    changeMode(): void {
        const routeLink = this.isSimpleMode ? '/home' : SIMPLE_MODE_PATH.HOME;

        // 由于是该按钮触发修改SWITCH.IS_SIMPLE_MODE，因此这里获取到的是旧值，最新值需要取反再传入
        this.simpleModeService.modifyUserPreferenceMode(!SWITCH.IS_SIMPLE_MODE)
            .pipe(catchError((err: HttpResponse) => throwError(err)))
            .subscribe((res: HttpResponse) => res);
        this.router.navigate([routeLink], {});
    }
}
